// src/components/PublicLayout.jsx

import { useTheme, useMediaQuery } from "@mui/material";
import { Outlet } from "react-router-dom";
import NavBar from "./NavBar";
import NavBarMobile from "./NavBarMobile";

export default function PublicLayout() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  return (
    <>
      {isMobile ? <NavBarMobile /> : <NavBar />}
      <Outlet />
    </>
  );
}
